<template>
  <div class="header-logo-wrapper">
    <div class="logo-wrapper">
      <router-link :to="'/'" custom v-slot="{ navigate }">
        <a href="javascript:void(0)" @click="navigate($event)">
          <img class="img-fluid" src="../../assets/images/logo/logo.png" alt />
        </a>
      </router-link>
    </div>
    <div class="logo-icon-wrapper">
      <router-link :to="'/'" custom v-slot="{ navigate }">
        <a href="javascript:void(0)" @click="navigate($event)">
          <img
          class="img-fluid"
          src="../../assets/images/logo/logo-icon.png"
          alt=""
      />
          </a>
      </router-link>
    </div>
    <div class="toggle-sidebar" @click="toggle_sidebar">
      <feather class="status_toggle middle sidebar-toggle" type="sidebar" id="sidebar-toggle" v-if="togglesidebar"></feather>
      <feather class="status_toggle middle sidebar-toggle" type="sidebar" id="sidebar-toggle" v-if="!togglesidebar"></feather>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  computed: {

    togglesidebar() {
      return this.$store.state.menu.togglesidebar;
    },
  },
  methods: {
    toggle_sidebar() {
      this.$store.dispatch('menu/opensidebar');
    },
  },
};
</script>
